import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Store } from '@ngrx/store';
import { deleteFundSources, getFundSources } from './ping.actions';
import { PingPartialState } from './ping.reducer';
import { selectPingFundSources } from './ping.selectors';
import { IFundSource, IFundSources } from "@classifieds-sell/datalayer";

@Injectable()
export class PingFacade {
    constructor(private store: Store<PingPartialState>) {}

    public loadPingFundSources() {
        this.store.dispatch(getFundSources());
    }

    public selectPingFundSources(): Observable<IFundSources> {
        return this.store.select(selectPingFundSources);
    }

    public deletePingFundSource(fundSource: IFundSource) {
        this.store.dispatch(deleteFundSources({ fundSource }));
    }
}
